module.exports = __webpack_public_path__ + "public/files/img/mentors.9fc7dd17.gif";